import { useRef, useState } from 'react'
import styles from './styles/register.module.css'
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri'
import parsePhoneNumber from 'libphonenumber-js'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import SigninIcon from '../../src/assests/icons/signinIcon.png';


export default function Register({setToken}) {
    const [passwordVisiblity, setPasswordVisiblity] = useState(false)
    const [cPasswordVisiblity, setCPasswordVisiblity] = useState(false)

    const navigate = useNavigate()

    const FNameRef = useRef()
    const LNameRef = useRef()
    const EmailRef = useRef()
    const PhNumRef = useRef()
    const PassRef = useRef()
    const CPassRef = useRef()

    function formValidator(input, condition, error){
        error[0].innerText = ""
        input.style.borderColor = "transparent"

        if(!condition && error[2]){
            error[0].innerText = error[1]
            input.style.borderColor = "red"
        }

        return condition
    }

    function FNameCheck(showErrOnCondition = true) {
        const input = FNameRef.current.children[1]
        const condition = (input.value.length > 0)
        const error = [FNameRef.current.children[2],"name is required", showErrOnCondition ? (input.value.length > 3) : true]

        return formValidator(input,condition,error)
    }

    function LNameCheck(showErrOnCondition = true) {
        const input = LNameRef.current.children[1]
        const condition = (input.value.length > 0)
        const error = [LNameRef.current.children[2],"name is required", showErrOnCondition ? (input.value.length > 3) : true]

        return formValidator(input,condition,error)
    }

    function EmailCheck(showErrOnCondition = true) {
        const input = EmailRef.current.children[1]
        const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const condition = emailValidator.test(input.value)
        const error = [EmailRef.current.children[2],"Valid Email is required", showErrOnCondition ? (input.value.includes("@") || input.value.length > 7) : true]


        return formValidator(input,condition,error)
    }

    function PhNumCheck(showErrOnCondition = true) {
        const input = PhNumRef.current.children[1]
        const phoneNumber = parsePhoneNumber(input.value)
        const condition = input.value.match(/^\+?[0-9]\d{1,20}$/);
        const error = [PhNumRef.current.children[2],"Valid Phone No is required", showErrOnCondition ? (input.value.length > 7) : true]

        return formValidator(input,condition,error)
    }

    function PassCheck(showErrOnCondition = true) {
        const input = PassRef.current.children[1]
        const otherPass = CPassRef.current.children[1].value
        const condition = (input.value.length > 0 && otherPass.length > 0) && (input.value == otherPass)
        const error = [PassRef.current.children[2],"Passwords did not match", showErrOnCondition ? (input.value.length > 5) : true]

        if(formValidator(input,condition,error)){
            CPassRef.current.children[2].innerText = " "
            CPassRef.current.children[1].style.borderColor = "transparent"
            return true
        }
        else return false
    }

    function CPassCheck(showErrOnCondition = true) {
        const input = CPassRef.current.children[1]
        const otherPass = PassRef.current.children[1].value
        const condition = (input.value.length > 0 && otherPass.length > 0) && (input.value == otherPass)
        const error = [CPassRef.current.children[2],"Passwords did not match", showErrOnCondition ? (input.value.length > 5) : true]

        if(formValidator(input,condition,error)){
            PassRef.current.children[2].innerText = " "
            PassRef.current.children[1].style.borderColor = "transparent"
            return true
        }
        else return false
    }

    function handleSubmit (e) {
        console.warn("sdfghjklkjhfdsdfghjk")
        e.preventDefault()
        const tests = [FNameCheck(false), LNameCheck(false), EmailCheck(false), PhNumCheck(false), PassCheck(false), CPassCheck(false)]
        const isPassed = !tests.includes(false)
        if(isPassed){
            const formBody = {
                name: FNameRef.current.children[1].value + " " + LNameRef.current.children[1].value,
                email: EmailRef.current.children[1].value,
                password: PassRef.current.children[1].value,
                phone: PhNumRef.current.children[1].value
            }
            fetch("https://friendly-jepsen.77-68-82-89.plesk.page/user/signup", {
                method: "POST",
                body: JSON.stringify(formBody),
                headers:{
                    "content-type": "application/json"
                }
            })
            .then(res=>res.json())
            .then(({token, err})=>{
                if(err){
                    console.log(err)
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Try Again',
                      })
                }
                else{
                    setToken(token)
                        localStorage.setItem("access_token", token)
                        const stage = localStorage.getItem("highestStage"),
                        state = localStorage.getItem("state")
                        if(stage && stage) navigate("/customizer?stage="+stage)
                        else navigate("/")
                }
            })

        }
    }

    return (
        <div className={styles.register}>
            <h1>Create an account</h1>
            <p>This allows instant access to your saved design.</p>
            <p> It’s quick, easy and very useful!</p>
            <form className={styles.form}>
                <fieldset ref={FNameRef}>
                    <legend>Full Name</legend>
                    <input type="text" name="Ename" onChange={FNameCheck} />
                    <p> </p>
                </fieldset>
                <fieldset ref={LNameRef}>
                    <legend>Last Name</legend>
                    <input type="text" name="Ename" onChange={LNameCheck} />
                    <p> </p>
                </fieldset>
                <fieldset ref={EmailRef}>
                    <legend>Email</legend>
                    <input type="email" name="Ename" onChange={EmailCheck} />
                    <p> </p>
                </fieldset>
                <fieldset ref={PhNumRef}>
                    <legend>Phone Number</legend>
                    <input type="phone" name="Ename" onChange={PhNumCheck} />
                    <p> </p>
                </fieldset>
                <fieldset ref={PassRef}>
                    <legend>Create Password</legend>
                    <input type={passwordVisiblity ? "text" : "password"} name="Ename" onChange={PassCheck} />
                    <p> </p>
                    {
                        passwordVisiblity ?
                            <RiEyeFill className={styles.hideshow} onClick={() => { setPasswordVisiblity(!passwordVisiblity) }} />
                            :
                            <RiEyeOffFill className={styles.hideshow} onClick={() => { setPasswordVisiblity(!passwordVisiblity) }} />
                    }
                </fieldset>
                <fieldset ref={CPassRef}>
                    <legend>Confirm Password</legend>
                    <input type={cPasswordVisiblity ? "text" : "password"} name="Ename" onChange={CPassCheck} />
                    <p> </p>
                    {
                        cPasswordVisiblity ?
                            <RiEyeFill className={styles.hideshow} onClick={() => { setCPasswordVisiblity(!cPasswordVisiblity) }} />
                            :
                            <RiEyeOffFill className={styles.hideshow} onClick={() => { setCPasswordVisiblity(!cPasswordVisiblity) }} />
                    }
                </fieldset>
                {/* <button className={styles.button} onClick={handleSubmit}>Create Account</button> */}
            </form>
                <div onClick={handleSubmit} className={styles.icon}><img src={SigninIcon} alt='loginIcon' /></div>
        </div>
    )
}